import { AssetUnitType } from '@jarvis/jweb-core';
import { Action, SIMPLE_UI_SCHEMA_VERSION, sendSimpleUiEvent } from 'jweb';
import { getAuthAccount, getPrinterInfo, isMobileHost, getAppId, getLocale } from './persistData';

const ANALYTICS = {
  SCREEN_NAME: 'Home',
  SCREEN_NAME_CEC_CAROUSEL: 'CecCarousel',
  SCREEN_PATH: '/EngagementCenter/',
  CONTROL_NAME: 'CecTile',
  SCREEN_PATH_CAROUSEL: '/EngagementCenter/CecCarousel/'
};

const toPascalCase = string => {
  return `${string}`
    .toLowerCase()
    .replace(new RegExp(/[-_]+/, 'g'), ' ')
    .replace(new RegExp(/[^\w\s]/, 'g'), '')
    .replace(new RegExp(/\s+(.)(\w*)/, 'g'), ($1, $2, $3) => `${$2.toUpperCase() + $3}`)
    .replace(/(^|\d)([a-z])/g, (_, prefix, letter) => prefix + letter.toUpperCase());
};

const getCountry = () => {
  try {
    const country = getLocale().split(/-|_/)[1].toUpperCase();
    return country;
  } catch (error) {
    return '';
  }
};

const getMetadata = () => {
  const { device_uuid, product_number } = getPrinterInfo();
  const { accountId } = getAuthAccount();
  return {
    assetUnit: isMobileHost() ? AssetUnitType.mobile : AssetUnitType.desktop,
    appInstanceId: getAppId().toLowerCase(),
    accountLoginId: accountId,
    country: getCountry(),
    deviceId: device_uuid,
    edgeType: product_number
  };
};

export const trackAppEventListenerSimpleUIEvent = activity => {
  sendSimpleUiEvent({
    eventData: {
      version: SIMPLE_UI_SCHEMA_VERSION,
      action: Action.controlToggleEnabled,
      screenPath: ANALYTICS.SCREEN_PATH_CAROUSEL,
      controlDetail: ANALYTICS.SCREEN_NAME,
      screenName: ANALYTICS.SCREEN_NAME,
      controlName: ANALYTICS.CONTROL_NAME
    },
    metaData: getMetadata()
  });
};

export const trackTileViewSimpleUIEvent = tiles => {
  if (!Array.isArray(tiles)) {
    tiles = new Array(tiles);
  }
  tiles.forEach(tile => {
    const name = toPascalCase(tile.analyticsData.name);
    sendSimpleUiEvent({
      eventData: {
        version: SIMPLE_UI_SCHEMA_VERSION,
        action: Action.controlDisplayed,
        screenPath: ANALYTICS.SCREEN_PATH_CAROUSEL,
        controlDetail: tile.analyticsData.name,
        screenName: name,
        controlName: name
      },
      metaData: getMetadata()
    });
  });
};

export const trackTileClickedSimpleUIEvent = tile => {
  const name = toPascalCase(tile.analyticsData.name);
  sendSimpleUiEvent({
    eventData: {
      version: SIMPLE_UI_SCHEMA_VERSION,
      action: Action.controlTileClicked,
      screenPath: ANALYTICS.SCREEN_PATH_CAROUSEL,
      controlDetail: tile.analyticsData.name,
      screenName: name,
      controlName: name
    },
    metaData: getMetadata()
  });
};

export const trackTileDismissalSimpleUIEvent = tile => {
  sendSimpleUiEvent({
    eventData: {
      version: SIMPLE_UI_SCHEMA_VERSION,
      action: Action.controlHyperLinkClicked,
      screenPath: ANALYTICS.SCREEN_PATH_CAROUSEL,
      screenName: toPascalCase(tile.analyticsData.name),
      controlDetail: tile.analyticsData.name,
      controlName: 'CloseButton'
    },
    metaData: getMetadata()
  });
};

export const trackLinkClickSimpleUIEvent = (linkPosition, linkName) => {
  sendSimpleUiEvent({
    eventData: {
      version: SIMPLE_UI_SCHEMA_VERSION,
      action: Action.controlHyperLinkClicked,
      screenPath: ANALYTICS.SCREEN_PATH_CAROUSEL,
      controlDetail: linkName,
      screenName: linkName,
      controlName: ANALYTICS.CONTROL_NAME
    },
    metaData: getMetadata()
  });
};

export const sendShowCECSimpleUIEvent = () => {
  sendSimpleUiEvent({
    eventData: {
      version: SIMPLE_UI_SCHEMA_VERSION,
      action: Action.moduleDisplayed,
      screenPath: ANALYTICS.SCREEN_PATH,
      controlDetail: ANALYTICS.SCREEN_NAME,
      screenName: ANALYTICS.SCREEN_NAME,
      controlName: ANALYTICS.CONTROL_NAME
    },
    metaData: getMetadata()
  });
};
